import { TEALIUM_CUSTOM_EVENT } from "../../constants.js";
const createCustomEvent = (detail) => {
  return new CustomEvent(TEALIUM_CUSTOM_EVENT, { detail });
};
export {
  createCustomEvent
};
//# sourceMappingURL=utils.js.map
